module.exports = __webpack_public_path__ + "assets/images/72ea82758eebd396f93dc7f72b7c965f.png";